import React, { useEffect, useState } from "react";
import { getVitalsTrends } from "../../lib/api";
import { useQuery } from "@tanstack/react-query";
import {  format,  } from "date-fns";
import CustomBarChart from "../chart/Barchart";
import CircularChart from "../chart/CircularChart";
import { Link } from "react-router-dom";

const VitalDetails = (props) => {
  const { closeShowDetails, vital } = props;

  const [chartData, setChartData] = useState([]);
  const [duration, setDuration] = useState('all');
  const [days, setDays] = useState(1);
  const [averageMeasure, setAverageMeasure] = useState(null);

  
  // console.log(vital, "vitalll");
  const [tab, setTab] = useState('Today');
  const patientId = localStorage.getItem("patientId");

  const { data, isLoading } = useQuery({
    queryKey: ["vitalTrends",vital.name,patientId,duration,days],
    queryFn: () => getVitalsTrends(patientId,{vitals:vital.name,
      days:days,
      duration:duration}),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled:!!patientId
  });
  const getColor = (value) => {
    if (!vital?.is_range_applicable) {
      return {
        color: "#4BB543",
      };
    }
    if (value < vital?.allowed_range?.lower_limit) {
      return {
        color: "#B33A3A",
      };
    } else if (value > vital?.allowed_range?.upper_limit) {
      return {
        color: "#B33A3A",
      };
    }
    let color = "#B33A3A";

    if (
      value >= vital?.normal_range?.lower_limit &&
      value <= vital?.normal_range?.upper_limit
    ) {
      color = "#4BB543";
    } else if (value < vital?.normal_range?.lower_limit) {
      return {
        color: "#B33A3A",
      };
    } else if (value > vital?.normal_range?.upper_limit) {
      return {
        color: "#B33A3A",
      };
    }

    return { color };
  };
  useEffect(() => {
    if(data?.data?.result){
      const trends = data.data.result;
      const transformData= trends?.map((e) => {
        if(!e?.data[vital.name]?.value) return null
        return {
          name: format(new Date(e?.date), "dd/MM/yyyy"),
          measure:e?.data[vital.name]?.value,
        color:getColor(e?.data[vital.name]?.value).color}
      } )
      console.log(trends,'trends',transformData)
      const chartData = transformData?.filter((e) => !!e);
      console.log(chartData,'chartData')
      setChartData(chartData)
      if(chartData?.length > 0){
        const averageMeasure = calculateAverage(chartData);
       
        setAverageMeasure(averageMeasure)
      }else{
        setAverageMeasure(null)
      }
      
    }
  }, [data])
function calculateAverage(data) {
    // Calculate the total sum of measure values
    const totalSum = data.reduce((sum, entry) => sum + entry.measure, 0);
    
    // Calculate the average
    const average = totalSum / data.length;

    return Math.ceil(average) ;
}


  const tabs =[
    {name:'Today'},{name:'Week'},{name:'Month'},{name:'Year'},
  ]
  useEffect(() => {
   switch (tab) {
    case 'Today':
      setDays(1)
      setDuration(null)
      break;
    case 'Week':
      setDays(7);
      setDuration(null)
      break;
    case 'Month':
      setDays(30);
      setDuration(null)
      break;
    case 'Year':
      setDuration('year')
      setDays(null)
      break;
    default:
      break;
   }
  }, [tab])
  
  return (
    <div className="container">
      <div className="flex py-2">

          <Link className="flex" onClick={closeShowDetails}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">{vital.display_name}</h4>
            </div>
          </Link>
        


      </div>
      <div className="flex flex-col sm:flex-row gap-4 pb-4">
        <div className="flex flex-col gap-4 h-90 w-full sm:w-[300px] rounded-[34px] border border-solid border-[#E4E9F1] p-4">
          <div className="flex justify-center items-center ">
            <CircularChart vital={vital} color={getColor(vital.value).color} />
          </div>
          <div className="w-35 grid grid-cols-2 gap-2 ">
            <div className="w-15 flex justify-start items-center  font-regular text-[16px] text-[#32365C]">
              <div
                className="rounded-full  h-[10px] w-[10px]"
                style={{ backgroundColor: "#B33A3A" }}
              ></div>
              <p className="ms-1">
                Low {vital?.allowed_range?.lower_limit} -{" "}
                {vital?.normal_range?.lower_limit}
              </p>
            </div>

            <div className="w-15 flex justify-start items-center  font-regular text-[16px] text-[#32365C]">
              <div
                className="rounded-full  h-[10px] w-[10px]"
                style={{ backgroundColor: "#4BB543" }}
              ></div>
              <p className="ms-1">
                Normal {vital?.normal_range?.lower_limit}
                {"-"}
                {vital?.normal_range?.upper_limit} {"  "}
              </p>
            </div>
            <div className="w-15 flex justify-start items-center  font-regular text-[16px] text-[#32365C]">
              <div
                className="rounded-full  h-[10px] w-[10px]"
                style={{ backgroundColor: "#B33A3A" }}
              ></div>
              <p className="ms-1">
                High {vital?.normal_range?.upper_limit} -{" "}
                {vital?.allowed_range?.upper_limit}
              </p>
            </div>
          </div>
          <div className="flex flex-row gap-2  text-center ">
            <p className="flex flex-1 flex-col">
              <span className="font-semibold text-xl text-[#141B34]">
                {vital.value}
              </span>{" "}
              <span className="font-regular text-[16px] text-[#575868]">
                Latest{"(10:00 AM)"}
              </span>
            </p>
            <p className="flex flex-1 flex-col">
              <span className="font-semibold text-xl text-[#141B34]">
                {vital?.normal_range?.lower_limit}
                {"-"}
                {vital?.normal_range?.upper_limit}
              </span>{" "}
              <span className="font-regular text-[16px] text-[#575868]">
                Normal Range
              </span>
            </p>
          </div>
        </div>
        {vital?.is_trend_applicable && chartData && (
          <div className="flex-1 h-90 rounded-[34px] border border-solid border-[#E4E9F1] px-3 py-3">
            <div className="flex flex-col sm:flex-row gap-1 justify-between">
              {averageMeasure && <p className="px-4 py-1">
                <span className="text-2xl xl:text-xl lg:text-lg font-semibold text-[#141B34]">
                {averageMeasure}
                </span>
                {/* <span className="font-regular text-[16px] xl:text-[16px] l:text-[14px] text-[#141B34] ">
                  {" "}
                  Normal
                </span> */}
                <br />
                <p className="font-regular text-[20px] xl:text-[20px] lg:text-[18px] text-[#575868]">
                  {`Average ${tab}`}
                </p>
              </p>}
              <div className="">
                <div
                  role="tablist"
                  aria-label="tabs"
                  className=" w-full 2xl:w-[28rem] xl:w-[25rem] lg:w-[23rem] md:w-[22rem] sm:w-[15rem] xl:ms-[3rem] h-11 grid grid-cols-4 items-center mt-[10px] rounded-[10px]  border border-solid border-[#E4E9F1]"
                >
                  {tabs.map((e)=>  <button
                    onClick={() => {
                      setTab(e.name);
                     
                    }}
                    role="tab"
                    aria-selected="true"
                    aria-controls="panel-1"
                    id="tab-1"
                    className={`${
                      tab === e.name ? ` bg-[#194CA6] text-white` : ``
                    } h-10 text-xs px-3 tab rounded-[10px]`}
                  >
                    <span className="">{e.name}</span>
                  </button>)}
                 
                
                </div>
              </div>
            </div>
            <CustomBarChart chartData={chartData} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VitalDetails;
